import React from 'react';
import {omit} from 'lodash';

export function EditableCell(props) {
    const {children, dataIndex, record, editing, title, editor, editMode, handleSave, isEditingThisRow} = props;
    const rest = omit(
        props,
        'children',
        'record',
        'editing',
        'title',
        'editor',
        'editMode',
        'dataIndex',
        'handleSave',
        'dataIndex',
        'isEditingThisRow',
    );
    // ExpandedRow cells (from antd Table's expandable feature) route
    // through the same body.cell component but carry no `record` via
    // onCell — guard so those render as plain cells.
    if (!record) {
        return <td {...rest}>{children}</td>;
    }
    // Prefer the explicit isEditingThisRow flag from the column's onCell
    // (it knows about pendingRename), otherwise fall back to matching
    // editing against the row keys so existing call sites without the
    // flag still work.
    const matches =
        typeof isEditingThisRow === 'boolean'
            ? isEditingThisRow
            : editing === record.key || editing === record.name;
    return editMode && editor && matches && !record.$ref ? (
        <td {...rest}> {editor({record, editMode, onSave: handleSave, title, dataIndex})} </td>
    ) : (
        <td {...rest}>{children}</td>
    );
}
